<div class="d-flex">
  <!-- Form -->
  <form (ngSubmit)="this.form.submit()" [formGroup]="this.form" class="flex-grow-1">

    <div class="row">
      <div class="col-12">
        <h1 id="determination-applicabilite-calcul"> Détermination de l'applicabilité du calcul </h1>

        <!-- isRollover -->
        <magieno-boolean-select
        [advancedFormControl]="this.isRollover"></magieno-boolean-select>

        @if (this.form.value.metadata?.isRollover === true) {
          <div class="alert alert-danger"
            role="alert">
            <p><i class="fas fa-exclamation-circle"></i>
            Veuillez utiliser l’outils “Roulement fiscal”. Le calcul “Vente d’actions” ne peut s’appliquer car
            vous avez sélectionné
            qu’il s’agit d’un roulement fiscal selon l’article 85 LIR.
          </p>
          <p>
            <a [queryParams]="{default: calculationKeynameEnum.Rollover}" class="btn btn-secondary btn-sm" href=""
              routerLink="../../create" style="margin-right: 15px;">Aller à
            Roulement fiscal</a>
          </p>
        </div>
      }

      <!-- isBuyerTheCorporationSellingItsShares -->
      <magieno-boolean-select
      [advancedFormControl]="this.form.formElements.isBuyerTheCorporationWhoseSharesAreBeingSold | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.form.value.isBuyerTheCorporationWhoseSharesAreBeingSold=== true) {
        <div class="alert alert-danger"
          role="alert">
          <p><i class="fas fa-exclamation-circle"></i>
          <!--                    Veuillez utiliser l’outils “Rachat d’actions”. -->
          Le calcul “Vente d’actions” ne peut s’appliquer car
          vous avez sélectionné que l’acheteur est une société qui achète ou rachète des actions de son
          capital-actions.
        </p>
        <!--                <p>-->
        <!--                    <a href="" class="btn btn-secondary btn-sm" routerLink="../" style="margin-right: 15px;">Aller à-->
      <!--                        Rachat d'actions</a>-->
    <!--                </p>-->
  </div>
}
</div>
</div>

<div class="row mt-5">
  <div class="col-12">
    <h1 id="information-de-base-sur-les-actions-vendues">Informations de base sur les actions vendues </h1>

    <!-- proceedsOfDisposition -->
    <magieno-input-money-field
      [advancedFormControl]="this.form.formElements.proceedsOfDisposition | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <!-- nonShareConsideration -->
    <magieno-input-money-field
      [advancedFormControl]="this.form.formElements.nonShareConsideration | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <!-- adjustedCostBaseOfTransferredShares -->
    <magieno-input-money-field
      [advancedFormControl]="this.form.formElements.adjustedCostBaseOfTransferredShares | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <!-- sellingFees -->
    <magieno-input-money-field [advancedFormControl]="this.form.formElements.sellingFees | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

  </div>
</div> <!-- / .row -->


<div class="row mt-5">
  <div class="col-12">
    <h1 id="conditions-application-article-84-1">Conditions d’application de l’article 84.1 LIR</h1>
    <!-- areTransferredSharesCanadianShares -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.areTransferredSharesCanadianShares | asAdvancedFormControl"></magieno-boolean-select>

    <!-- areTransferredSharesCapitalPropertyForTheSeller -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.areTransferredSharesCapitalPropertyForTheSeller | asAdvancedFormControl"></magieno-boolean-select>

    <!-- isSellerAnIndividualOrATrust -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.isSellerAnIndividualOrATrust | asAdvancedFormControl"></magieno-boolean-select>

    <!-- isSellerACanadianResident -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.isSellerACanadianResident | asAdvancedFormControl"></magieno-boolean-select>

    <!-- isBuyerACorporation -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.isBuyerACorporation | asAdvancedFormControl"></magieno-boolean-select>

    <!-- areBuyerAndSellerAtArmsLength -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.areBuyerAndSellerAtArmsLength | asAdvancedFormControl"></magieno-boolean-select>

    <!-- isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction -->
    <magieno-boolean-select
    [advancedFormControl]="this.form.formElements.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction | asAdvancedFormControl"></magieno-boolean-select>
  </div>
</div> <!-- / .row -->


<div class="row">
  <div class="col-12">
    <h1 [attr.aria-expanded]="!isSection84_1Collapsed"
      aria-controls="section84_1Applicable"
      class="mt-3">
      Informations pour l’article 84.1 LIR
    </h1>

    <!--            <div #collapseSection84_1Applicable="ngbCollapse" [(ngbCollapse)]="isSection84_1Collapsed">-->
    <div class="card ">
      <div class="card-body pb-5" style="position: relative;">
        @if (isSection84_1Applicable) {
          <div class="alert alert-warning" id="section84_1ApplicableAlert"
            role="alert">
            <i class="fas fa-exclamation-triangle"></i> Attention! L’article 84.1 L.I.R.
            s’applique à cette transaction donc vous devez remplir le formulaire additionnel.
          </div>
        }

        @if (isSection84_1Applicable === false) {
          <div class="alert alert-light" id="section84_1NotApplicableAlert"
            role="alert">
            <i class="fas fa-exclamation-triangle"></i> L’article 84.1 L.I.R. ne s’applique pas
            à cette transaction donc vous n'avez pas à rentrer les informations ci-dessous.
          </div>
        }

        <div class="text-center" style="position: absolute; bottom: 10px; width: 100%;">
          <button (click)="collapseSection84_1Applicable.toggle()"
            class="shadow btn btn-link btn-outline-light rounded-pill"
            style="">
            @if (isSection84_1Collapsed) {
              <span><i
              class="fas fa-angle-double-down"></i> Agrandir</span>
            }
            @if (!isSection84_1Collapsed) {
              <span><i class="fas fa-angle-double-up"></i> Réduire</span>
            }
          </button>
        </div>


        <div #collapseSection84_1Applicable="ngbCollapse" [(ngbCollapse)]="isSection84_1Collapsed"
          class="row">
          <div class="col-12">
            <!-- paidUpCapitalOfGiftedShares -->
            <magieno-input-money-field
              [advancedFormControl]="this.form.formElements.paidUpCapitalOfGiftedShares | asAdvancedFormControl"
              [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>

            <!-- capitalGainsOnTheShareDeclaredAfter1984 -->
            <magieno-input-money-field
              [advancedFormControl]="this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984 | asAdvancedFormControl"
              [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>

            <!-- wereSharesAcquiredAfter1971 -->
            <magieno-boolean-select
            [advancedFormControl]="this.form.formElements.wereSharesAcquiredAfter1971 | asAdvancedFormControl"></magieno-boolean-select>


            @if (this.form.value.wereSharesAcquiredAfter1971 === false) {
              <div
                class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="row">
                      <div class="col-12">
                        <!-- fairMarketValueOnValuationDayOfTransferredShares -->
                        <magieno-input-money-field
                          [advancedFormControl]="this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares | asAdvancedFormControl"
                          [currency]="this.currency"
                        [locale]="this.locale"></magieno-input-money-field>
                      </div>
                    </div> <!-- / .row -->
                    <div class="row">
                      <div class="col-12">
                        <!-- actualCostOnJanuary1972OfTransferredShares -->
                        <magieno-input-money-field
                          [advancedFormControl]="this.form.formElements.actualCostOnJanuary1972OfTransferredShares | asAdvancedFormControl"
                          [currency]="this.currency"
                        [locale]="this.locale"></magieno-input-money-field>
                      </div>
                    </div> <!-- / .row -->
                    <div class="row">
                      <div class="col-12">
                        <!-- receivedDividendChoice83OnTransferredShares -->
                        <magieno-input-money-field
                          [advancedFormControl]="this.form.formElements.receivedDividendChoice83OnTransferredShares | asAdvancedFormControl"
                          [currency]="this.currency"
                        [locale]="this.locale"></magieno-input-money-field>
                      </div>
                    </div> <!-- / .row -->
                  </div>
                </div>
              </div>
            }
          </div>
        </div> <!-- / .row -->
      </div>
    <!--                </div>-->
  </div>
</div>


</div>

<div class="row">
  <div class="col-12">
    <h1 id="shareClass">Actions reçues en contrepartie</h1>

    @for (shareClass of this.shareClasses.formGroups; track shareClass; let i = $index) {
      <div class="card">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h2 [id]="'shares-category-' + (i + 1)">Catégorie d'actions #{{ i + 1 }}</h2>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="this.shareClasses.delete(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- title -->
              <magieno-input-text-field [advancedFormControl]="shareClass.formElements.title | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
              <!-- initialPaidUpCapital -->
              <magieno-input-money-field
                [advancedFormControl]="shareClass.formElements.initialPaidUpCapital | asAdvancedFormControl"
                [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
              <!-- numberOfSharesIssued -->
              <magieno-input-number-field
              [advancedFormControl]="shareClass.formElements.numberOfSharesIssued | asAdvancedFormControl"></magieno-input-number-field>
              <!-- numberOfSharesBeforeShareIssuance -->
              <magieno-input-number-field
              [advancedFormControl]="shareClass.formElements.numberOfSharesBeforeShareIssuance | asAdvancedFormControl"></magieno-input-number-field>
              <!-- increasePaidUpCapitalDueToShareIssuance -->
              <magieno-input-money-field
                [advancedFormControl]="shareClass.formElements.increasePaidUpCapitalDueToShareIssuance | asAdvancedFormControl"
                [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
              <!-- initialAdjustedCostBase -->
              <magieno-input-money-field
                [advancedFormControl]="shareClass.formElements.initialAdjustedCostBase | asAdvancedFormControl"
                [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
              <!-- fairMarketValueOfSharesIssued -->
              <magieno-input-money-field
                [advancedFormControl]="shareClass.formElements.fairMarketValueOfSharesIssued | asAdvancedFormControl"
                [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
            </div>
          </div> <!-- / .row -->
        </div>
      </div>
    }

    <div class="card">
      <div (click)="this.shareClasses.appendNew()" class="card-body" style="cursor: pointer">
        <a (click)="$event.preventDefault()" href="#shareClass" id="addShareClassButton">+ Ajouter une
        catégorie d'actions</a>
      </div>
    </div>

  </div>
</div>

<br>
  <br>
    <br>
      <br>

        <!-- Button -->
        <div class="row fixed-bottom">
          <div class="col-12">
            <magieno-button [button]="this.form.getButton('SAVE')" id="saveCalculationButton"></magieno-button>

            <magieno-button [button]="this.form.getButton('EXECUTE')" id="executeCalculationButton"
            style="margin-left: 12px"></magieno-button>

            <span [class.bg-danger]="calculationStatusEnum === 'ERROR'"
              [class.bg-light]="calculationStatusEnum === 'CREATED'"
              [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
              [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
              class="badge rounded-pill ms-5"
              style="font-size: 12pt;"

            >{{ getStatusText() }}</span>

            <button (click)="openErrorsSidebar()" [class.bg-danger]="this.numberOfErrors > 0"
              [class.bg-success]="this.numberOfErrors === 0"
              class="btn badge rounded-pill ms-3"
              style="font-size: 12pt;">{{ this.numberOfErrors }}
              erreurs
            </button>

            <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>

          </div>
        </div>


      </form>

      <app-calculation-form-sidebar></app-calculation-form-sidebar>

    </div>
